import * as Yup from "yup";

export const ContactValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Required!"),
  lastName: Yup.string().required("Required!"),
  email: Yup.string().email("Invalid email").required("Required!"),
});
